import { z } from 'zod';

import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema } from '../chat-ids';

export const sharedStructuredEventShape = {
    eventId: chatEventIdSchema,
    eventType: z.literal('structured-response'),
    messageId: chatMessageIdSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
} as const;
